import {
  CreditCard,
  CurrencyDollarIcon,
  HelpCenter,
  OnboardingIcon,
  People,
  Settings,
} from "assets/svg";
import { t } from "i18next";
import routes from "routes/routes";

import { HELP_CENTER } from "constants/shared";

import { IMainMenuItem } from "./types";

const _translationPrefix = `components.main_menu`;

export const MAIN_MENU_TRANSITION_DURATION = 250;
export const MAIN_MENU_ANIMATION_CLASS_NAME = "animate";
export enum MAIN_MENU_COLLAPSED_STATE_CLASS_NAME {
  COLLAPSED = "collapsed",
  NOT_COLLAPSED = "not-collapsed",
}

export const getAdminMainMenuOptions = (): IMainMenuItem[] => [
  {
    id: "setup",
    icon: <OnboardingIcon />,
    label: t(`${_translationPrefix}.setup`),
    url: routes.ADMIN_SETUP,
  },

  {
    id: "pay",
    icon: <CurrencyDollarIcon />,
    label: t(`${_translationPrefix}.pay_admin`),
    url: routes.ADMIN_PAY,
  },
  /*  NOTE::: PAIDSW-1183 - hide subscriptions
  {
    id: "timesheets",
    icon: <ClockAltSmallIcon />,
    label: t(`${_translationPrefix}.timesheets`),
    url: routes.ADMIN_TIMESHEETS,
  }, */
  {
    id: "people",
    icon: <People />,
    label: t(`${_translationPrefix}.people`),
    url: routes.PEOPLE,
  },
  {
    id: "banking",
    icon: <CreditCard />,
    label: t(`${_translationPrefix}.banking_admin`),
    url: routes.BANKING,
  },
  {
    id: "settings",
    icon: <Settings />,
    label: t(`${_translationPrefix}.settings_admin`),
    url: routes.ADMIN_SETTINGS,
  },
  {
    id: "help_center",
    icon: <HelpCenter />,
    label: t(`${_translationPrefix}.help_center`),
    href: HELP_CENTER,
  },
];

export const getEmployeeMainMenuOptions = (): IMainMenuItem[] => [
  {
    id: "setup",
    icon: <OnboardingIcon />,
    label: t(`${_translationPrefix}.setup`),
    url: routes.EMPLOYEE_SETUP,
  },
  {
    id: "pay",
    icon: <CurrencyDollarIcon />,
    label: t(`${_translationPrefix}.pay_employee`),
    url: routes.EMPLOYEE_PAY,
  },
  /*  NOTE::: PAIDSW-1183 - hide subscriptions
  {
    id: "timesheets",
    icon: <ClockAltSmallIcon />,
    label: t(`${_translationPrefix}.timesheets`),
    url: routes.EMPLOYEE_TIMESHEETS,
  }, */
  {
    id: "banking",
    icon: <CreditCard />,
    label: t(`${_translationPrefix}.banking_employee`),
    url: routes.BANKING,
  },
  {
    id: "settings",
    icon: <Settings />,
    label: t(`${_translationPrefix}.settings_employee`),
    url: routes.EMPLOYEE_SETTINGS,
  },
  {
    id: "help_center",
    icon: <HelpCenter />,
    label: t(`${_translationPrefix}.help_center`),
    href: HELP_CENTER,
  },
];
